export default __webpack_public_path__ + "static/media/bg7.a807f9ed.jpg";